import React, { useEffect, useState, useRef } from "react";
import { getAllLicenseDetail } from "../services/userServices";
import homeImage from "../assets/image/main_image.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "../assets/css/Homepage.css";
import { useNavigate, useParams } from "react-router-dom";
const LANGUAGES = [
  { label: "English", value: "en-US" },
  { label: "Korean", value: "ko-KR" },
  { label: "Japanese", value: "ja-JP" },
  { label: "Chinese", value: "zh" },
  { label: "Russian", value: "ru" },
  { label: "Vietnamese", value: "vi" },
];
const LANGUAGESTRANSLATE = [
  { label: "English", value: "en-US" },
  { label: "Korean", value: "ko-KR" },
  { label: "Japanese", value: "ja-JP" },
  { label: "Chinese", value: "zh" },
  { label: "Russian", value: "ru" },
  { label: "Vietnamese", value: "vi" },
];
const ENGINES = [
  { label: "Systran", value: "normalSystran" },
  { label: "Systran (Hyundai)", value: "huyndaiSystran" },
  { label: "Google", value: "gg" },
  { label: "DeepL", value: "dpl" },
  { label: "Papago", value: "ppg" },
];

function DetailsLicensePage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [showHide, setShowHide] = useState(false);
  const navigate = useNavigate();
  const tabbarRef = useRef(null);
  
    useEffect(() => {
      function handleClickOutside(event) {
        if (tabbarRef.current && !tabbarRef.current.contains(event.target)) {
          setShowHide(false);
        }
      }
      if (showHide) {
        document.addEventListener("mousedown", handleClickOutside);
      } else {
        document.removeEventListener("mousedown", handleClickOutside);
      }
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [showHide]);
  useEffect(() => {
    fetchLicenses();
  }, []);
  const { key } = useParams();
  const fetchLicenses = async () => {
    try {
      const response = await getAllLicenseDetail(key);
      setItems(response.baseRest.respObj);
    } catch (err) {
      setError("Failed to load licenses");
    } finally {
      setLoading(false);
    }
  };
  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/";
  };

  const openTabbar = () => {
    setShowHide(!showHide);
  };
  const handleNavigation = (path) => {
    navigate(path);
  };
  return (
    <>
      <div ref={tabbarRef} className={`tabbar ${showHide ? "open" : ""}`}>
        <ul>
          <li>
            <svg
              style={{ cursor: "pointer" }}
              onClick={openTabbar}
              fill="#000000"
              width="24px"
              height="24px"
              viewBox="0 -2 28 28"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                <path d="m5.216 11.998c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 2.608c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m5.216 21.389c0 1.44-1.168 2.608-2.608 2.608s-2.608-1.168-2.608-2.608 1.168-2.608 2.608-2.608 2.608 1.168 2.608 2.608z"></path>
                <path d="m9.794 0h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 9.39h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
                <path d="m9.794 18.781h15.247c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-15.247c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              </g>
            </svg>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/home")}
            >
              Home
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-license")}
            >
              License
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/manage-logo")}
            >
              Manage logo
            </div>
          </li>
          <li>
            <div
              className="option-tab"
              onClick={() => handleNavigation("/change-password")}
            >
              Change password
            </div>
          </li>
        </ul>
      </div>
      <div
        style={{
          backgroundImage: `url(${homeImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          minHeight: "300px",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          //   alignItems: "center",
          //   justifyContent: "center",
          textAlign: "center",
          color: "black",
          fontSize: "2rem",
          fontWeight: "bold",
          textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
          position: "relative",
        }}
      >
        <div className="top-action">
          <svg
            onClick={openTabbar}
            fill="#000000"
            width="24px"
            height="24px"
            viewBox="0 -2 28 28"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              <path d="m2.61 0h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 9.39h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
              <path d="m2.61 18.781h22.431c1.441 0 2.61 1.168 2.61 2.61s-1.168 2.61-2.61 2.61h-22.431c-1.441 0-2.61-1.168-2.61-2.61s1.168-2.61 2.61-2.61z"></path>
            </g>
          </svg>
          <div
            style={{
              // position: "absolute",
              right: "10px",
              top: "20px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "14px",
              cursor: "pointer",
            }}
            onClick={logout}
          >
            <svg
              width="24px"
              height="24px"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
              <g
                id="SVGRepo_tracerCarrier"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></g>
              <g id="SVGRepo_iconCarrier">
                {" "}
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9 0L3 2V14H1V16H15V14H13V2H11V14H9V0ZM6.75 9C7.16421 9 7.5 8.55229 7.5 8C7.5 7.44772 7.16421 7 6.75 7C6.33579 7 6 7.44772 6 8C6 8.55229 6.33579 9 6.75 9Z"
                  fill="#000000"
                ></path>{" "}
              </g>
            </svg>
            Logout
          </div>
        </div>
        Manage License Config
      </div>
      <div className="container mt-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <svg
            onClick={() => navigate(-1)}
            style={{ cursor: "pointer" }}
            width="24px"
            height="24px"
            viewBox="0 0 32 32"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            fill="#000000"
          >
            <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
            <g
              id="SVGRepo_tracerCarrier"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></g>
            <g id="SVGRepo_iconCarrier">
              {" "}
              <g id="icomoon-ignore"> </g>{" "}
              <path
                d="M14.389 7.956v4.374l1.056 0.010c7.335 0.071 11.466 3.333 12.543 9.944-4.029-4.661-8.675-4.663-12.532-4.664h-1.067v4.337l-9.884-7.001 9.884-7zM15.456 5.893l-12.795 9.063 12.795 9.063v-5.332c5.121 0.002 9.869 0.26 13.884 7.42 0-4.547-0.751-14.706-13.884-14.833v-5.381z"
                fill="#000000"
              >
                {" "}
              </path>{" "}
            </g>
          </svg>
          <h1 className="text-center" style={{ fontSize: "24px" }}>
            List User Active
          </h1>
        </div>

        {loading && <p>Loading...</p>}
        {error && <div className="alert alert-danger">{error}</div>}

        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>#</th>
                <th>Key</th>
                <th>Mac Address</th>
                <th>Languages</th>
                <th>Translation Engines</th>
                <th>Expired Day</th>
              </tr>
            </thead>
            <tbody>
              {!loading && !error && items.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center text-muted">
                    No data
                  </td>
                </tr>
              ) : (
                items.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td style={{ cursor: "pointer" }}>{item.key}</td>
                    <td style={{ cursor: "pointer" }}>{item.mac}</td>

                    <td>
                      {item.languages.map((lang, i) => {
                        const foundLang = LANGUAGES.find(
                          (l) => l.value === lang
                        );
                        return (
                          <span key={i} className="badge bg-primary me-1">
                            {foundLang ? foundLang.label : lang}
                          </span>
                        );
                      })}
                    </td>
                    <td>
                      {item.engines.map((eng, i) => {
                        const foundEng = ENGINES.find((e) => e.value === eng);
                        return (
                          <span key={i} className="badge bg-secondary me-1">
                            {foundEng ? foundEng.label : eng}
                          </span>
                        );
                      })}
                    </td>
                    <td>
                      {(() => {
                        const daysLeft = Math.ceil(
                          (new Date(item.expired).getTime() -
                            new Date().getTime()) /
                            (1000 * 60 * 60 * 24)
                        );

                        if (item.expired === 9999 || daysLeft > 4000) {
                          return <>Permanently</>;
                        }

                        return (
                          <>
                            {daysLeft > 0 ? `${daysLeft} Days Left` : "Expired"}
                          </>
                        );
                      })()}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default DetailsLicensePage;
